export const isSea = import.meta.env.MODE?.includes("sea");
export const isLna = import.meta.env.MODE?.includes("lna");
export const isHmt =
  import.meta.env.MODE?.includes("hmt") || (!isSea && !isLna);

// const ENV_CONFIG = {
//   SEA: {
//     appId: "873582734092462",
//     lang: "en",
//   },
//   LNA: {
//     appId: "820791479705055",
//     lang: "en",
//   },
//   HMT: {
//     appId: "1549318245440048",
//     lang: "zh_TW",
//   },
// } as const;

// 判断哪个环境
export const getEnvConfig = () => {
  if (isSea) {
    return {
      env: "sea",
    };
  } else if (isLna) {
    return {
      env: "lna",
    };
  } else {
    return {
      env: "hmt",
    };
  }
};
